import { v4 as uuid } from 'uuid';
import { formatDate } from '../utils/authUtils';
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: 'Nikhil',
    lastName: 'Belide',
    username: 'nikhilbelide',
    email: 'nikhilbelide@gmail.com',
    password: 'nikhilbelide123',
    createdAt: formatDate(),
    updatedAt: formatDate(),
    avatar: 'https://joesch.moe/api/v1/jean',
    bio: 'Confused Web Developer(.ing)',
    portfolio: 'https://peerlist.io/nikhilbelide',
    followers: [],
    following: [
      {
        _id: uuid(),
        firstName: 'Admin',
        lastName: 'Kumar',
        username: 'adminkumar',
        avatar: 'https://joesch.moe/api/v1/joe',
      },
    ],
    bookmarks: [],
  },
  {
    _id: uuid(),
    firstName: 'Pritam',
    lastName: 'Kumar',
    username: 'pritamkr_',
    email: 'pritamkumar@gmail.com',
    password: 'pritamkumar123',
    createdAt: formatDate(),
    updatedAt: formatDate(),
    avatar: 'https://joesch.moe/api/v1/jordan',
    bio: 'Learning web development skills.',
    portfolio: 'https://pritam-kumar.netlify.app',
    followers: [],
    following: [
      {
        _id: uuid(),
        firstName: 'Admin',
        lastName: 'Kumar',
        username: 'adminkumar',
        avatar: 'https://joesch.moe/api/v1/joe',
      },
    ],
    bookmarks: [],
  },
  {
    _id: uuid(),
    firstName: 'Himadri',
    lastName: 'Shah',
    username: 'himadri2110',
    email: 'himadrishah@gmail.com',
    password: 'himadrishah123',
    createdAt: formatDate(),
    updatedAt: formatDate(),
    avatar: 'https://joesch.moe/api/v1/jeane',
    bio: 'Web developer',
    portfolio: 'https://himadrishah.tech',
    followers: [],
    following: [
      {
        _id: uuid(),
        firstName: 'Admin',
        lastName: 'Kumar',
        username: 'adminkumar',
        avatar: 'https://joesch.moe/api/v1/joe',
      },
    ],
    bookmarks: [],
  },
  {
    _id: uuid(),
    firstName: 'Mahesh',
    lastName: 'Deshmukh',
    username: 'msdeshmukh09',
    email: 'msdeshmukh@gmail.com',
    password: 'msdeshmukh123',
    createdAt: formatDate(),
    updatedAt: formatDate(),
    avatar: 'https://joesch.moe/api/v1/josh',
    bio: 'Web developer | JavaScript | React',
    portfolio: 'https://maheshdeshmukh.netlify.app',
    followers: [],
    following: [
      {
        _id: uuid(),
        firstName: 'Admin',
        lastName: 'Kumar',
        username: 'adminkumar',
        avatar: 'https://joesch.moe/api/v1/joe',
      },
    ],
    bookmarks: [],
  },
  {
    _id: uuid(),
    firstName: 'Admin',
    lastName: 'Kumar',
    username: 'adminkumar',
    email: 'adminkumar@gmail.com',
    password: 'admin@123',
    createdAt: formatDate(),
    updatedAt: formatDate(),
    avatar: 'https://joesch.moe/api/v1/jai',
    bio: 'Frontend Engineer',
    portfolio: 'https://github.com',
    following: [
      {
        _id: uuid(),
        firstName: 'Nilesh',
        lastName: 'Kumar',
        username: 'Nilesh Kumar',
        avatar: 'https://joesch.moe/api/v1/james',
      },
      {
        _id: uuid(),
        firstName: 'Elon',
        lastName: 'Musk',
        username: 'elonmusk',
        avatar: 'https://joesch.moe/api/v1/jana',
      },
    ],
    followers: [
      {
        _id: uuid(),
        firstName: 'Mahesh',
        lastName: 'Deshmukh',
        username: 'msdeshmukh09',
        avatar: 'https://joesch.moe/api/v1/josh',
      },
      {
        _id: uuid(),
        firstName: 'Nikhil',
        lastName: 'Belide',
        username: 'nikhilbelide',
        avatar: 'https://joesch.moe/api/v1/jean',
      },
      {
        _id: uuid(),
        firstName: 'Pritam',
        lastName: 'Kumar',
        username: 'pritamkr_',
        avatar: 'https://joesch.moe/api/v1/jordan',
      },
    ],
    bookmarks: [],
  },
  {
    _id: uuid(),
    firstName: 'Nilesh',
    lastName: 'Kumar',
    username: 'Nilesh Kumar',
    email: 'nileshkumarjune@gmail.com',
    password: 'Nilesh@2002',
    createdAt: formatDate(),
    updatedAt: formatDate(),
    avatar: 'https://joesch.moe/api/v1/james',
    bio: 'Building Frontend',
    portfolio: 'https://github.com/NILESHSINGH234',
    following: [
      {
        _id: uuid(),
        firstName: 'Elon',
        lastName: 'Musk',
        username: 'elonmusk',
        avatar: 'https://joesch.moe/api/v1/jana',
      },
    ],
    followers: [
      {
        _id: uuid(),
        firstName: 'Elon',
        lastName: 'Musk',
        username: 'elonmusk',
        avatar: 'https://joesch.moe/api/v1/jana',
      },
      {
        _id: uuid(),
        firstName: 'Admin',
        lastName: 'Kumar',
        username: 'adminkumar',
        avatar: 'https://joesch.moe/api/v1/joe',
      },
    ],
    bookmarks: [],
  },
  {
    _id: uuid(),
    firstName: 'Elon',
    lastName: 'Musk',
    username: 'elonmusk',
    email: 'elon@gmail.com',
    password: 'elonmusk123',
    createdAt: formatDate(),
    updatedAt: formatDate(),
    avatar: 'https://joesch.moe/api/v1/jana',
    bio: 'SpaceX | Tesla',
    portfolio: 'https://twitter.com/elonmusk',
    following: [
      {
        _id: uuid(),
        firstName: 'Nilesh',
        lastName: 'Kumar',
        username: 'nileshkumar',
        avatar: 'https://joesch.moe/api/v1/james',
      },
    ],
    followers: [
      {
        _id: uuid(),
        firstName: 'Nilesh',
        lastName: 'Kumar',
        username: 'nileshkumar',
        avatar: 'https://joesch.moe/api/v1/james',
      },
      {
        _id: uuid(),
        firstName: 'Admin',
        lastName: 'Kumar',
        username: 'adminkumar',
        avatar: 'https://joesch.moe/api/v1/joe',
      },
    ],
    bookmarks: [],
  },
];
